import React, { createContext, useContext, useState } from "react";
import { history } from "src/app.routes";
import { UserService } from "src/services/user.service";
import { clientRoutes } from "src/shared/constants";
const jwtCheckExpiration = require('jwt-check-expiration');

interface IAppContextState {
    isSidebarOpen: boolean;
    toggleSidebar: Function;
}

const AppContext = createContext<IAppContextState>({
    isSidebarOpen: true,
    toggleSidebar: () => {},
});

const AppProvider : React.FC = props => {
    // Used to open/close app sidebar
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(prevState => !prevState);
    }

    // If token is not authorized, logout user
    if(UserService?.GetAuthMSAuthorizationToken() && jwtCheckExpiration.isJwtExpired(UserService.GetAuthMSAuthorizationToken())) {
        UserService.SignOut();
    }

    return (
        <AppContext.Provider value={{
            isSidebarOpen: isSidebarOpen, toggleSidebar
        }}>
            {props.children}
        </AppContext.Provider>
    )
}

const useApp = () => useContext<IAppContextState>(AppContext);

export { AppProvider, useApp };





